module.exports = __webpack_public_path__ + "static/cancerreportimage-f763fe333b84efad11ea5412f588c230.png";